/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PersonalContactAliases {
  ADDIONAL_CONTACT_PHONE_NUMBER = 'addional-contact-phone-number',
  ADDIONAL_CONTACT_PHONE_NUMBER_FIELD = 'addional-contact-phone-number-field',
  ADDITIONAL_CONTACT_FIELD = 'additional-contact-field',
  ADDITIONAL_CONTACT_FIELD_LIST = 'additional-contact-field-list',
  FETCH_CONTACT = 'fetch-contact',
  FIELD_CONTACT_NAME = 'field-contact-name',
  FIELD_CONTACT_TYPE = 'field-contact-type',
  FIELD_NR_SEQUENCIA = 'field-nr-sequencia',
  FORM_CONTACT = 'form-contact',
  INPUT_0 = 'input-0',
  INPUT_CONTACT_NAME = 'input-contactName',
  INPUT_CONTACT_TYPE = 'input-contact-type',
  LAYOUT_CONTACT = 'layout-contact',
  PANEL_CONTACT = 'panel-contact',
}
export { PersonalContactAliases };
